import { HttpClient } from '@angular/common/http';
import { MOCK_URL_FOOTER } from '@ibe.config';
import { INDRAApiService } from './api.indra.service';
import { INDRAStorageService } from './storage.indra.service';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "./api.indra.service";
import * as i3 from "./storage.indra.service";
var INDRAFooterService = /** @class */ (function () {
    function INDRAFooterService(http, apiIndra, storage) {
        this.http = http;
        this.apiIndra = apiIndra;
        this.storage = storage;
    }
    INDRAFooterService.prototype.getFooter = function () {
        return this.http.get(MOCK_URL_FOOTER);
    };
    INDRAFooterService.ngInjectableDef = i0.defineInjectable({ factory: function INDRAFooterService_Factory() { return new INDRAFooterService(i0.inject(i1.HttpClient), i0.inject(i2.INDRAApiService), i0.inject(i3.INDRAStorageService)); }, token: INDRAFooterService, providedIn: "root" });
    return INDRAFooterService;
}());
export { INDRAFooterService };
